import React from 'react';

import { InversionButton } from './InversionButton';
import { CreditsButton } from './CreditsButton';
import styles from './Buttons.module.css';

interface Props { }

export function Buttons(props: Props) {
  return (
    <div className={styles['buttons']}>
      <InversionButton />
      <CreditsButton />
    </div>
  );
}
